(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('TipoOrdenamiento', TipoOrdenamiento);

    TipoOrdenamiento.$inject = ['$resource'];

    function TipoOrdenamiento ($resource) {
        var resourceUrl =  'api/tipo-ordenamientos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
